import { Form, Button, Input, Modal, Table, notification, Tag, Space, Select, InputNumber, Card, Checkbox } from 'antd'
import { useContext, useEffect, useState } from 'react'
import { PlusCircleTwoTone, MinusCircleOutlined, PlusOutlined, PauseCircleOutlined, PlayCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { EditFilled } from '@ant-design/icons'
import './styles.css'

import { Context } from '../../context'
import { Fetch, Post, Put, Patch } from '../../fetch'
import { convertIdToKey, frequentCurrencyCodes, otherCurrencycodes } from '../../utils'
const { Column } = Table
const { Option } = Select


const ManagePlans = () => {
  const { token, apiUrl } = useContext(Context)

  const [plans, setPlans] = useState([])
  const [applePlans, setApplePlans] = useState([])
  const [androidPlans, setAndroidPlans] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [planId, setPlanId] = useState()
  const [editPlan, setEditPlan] = useState({ price: {} })
  const [pageType, setPageType] = useState('web')
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  const [frequentCodes, setFrequentCodes] = useState(frequentCurrencyCodes)
  const [otherCodes, setOtherCodes] = useState(otherCurrencycodes)
  const [syncApplePlan, setSyncApplePlan] = useState(false)
  const [syncGooglePlan, setSyncGooglePlan] = useState(false)

  const [form] = Form.useForm()

  // useEffect(() => {
  //   if (frequentCodes.length === 0)
  //     // console.log(frequentCurrencyCodes)
  //     setFrequentCodes(frequentCurrencyCodes);
  //   if (otherCodes.length === 0)
  //     // console.log(otherCurrencycodes)
  //     setOtherCodes(otherCurrencycodes);
  // }, [frequentCurrencyCodes, otherCurrencycodes])

  useEffect(() => {
    if (pageType === "web") {
      setData(plans)
    }
    if (pageType === "apple") {
      setData(applePlans)
    }
    if (pageType === "android") {
      setData(androidPlans)
    }
  })

  useEffect(() => {
    if (pageType === 'web') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const plans = convertIdToKey(result.plans)
        plans.forEach(plan => {
          const type_of_isprivate = typeof (plan.isPrivate);

          if ((type_of_isprivate === "undefined") || (plan.isPrivate === "False")) {
            plan.isPrivate = "public";
          } else {
            plan.isPrivate = "private";
          }
          console.log("prices - ", plan.price)
          let c = plan.price
          let cu = []
          for (let i in plan.price) {
            console.log(c[i])
            cu = [...cu, c[i].symbol]
          }
          plan["defaultOptions"] = cu
        })
        setPlans(plans)
      }
      )
    }
    if (!planId) {
      return
    }

    Fetch(`${apiUrl}/plans/${planId}`, token, (result) => {
      const { ...others } = result;
      console.log("hello");
      form.setFieldsValue(others);
    })
  }, [apiUrl, token, pageType, confirmLoading])

  useEffect(() => {
    if (pageType === 'apple') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const apple_plans = convertIdToKey(result.plans)

        apple_plans.forEach(plan => {
          if (!plan.name) {
            plan.name = plan.planId
          }
        })
        setApplePlans(apple_plans);
      })
    }
  }, [apiUrl, token, pageType, confirmLoading])

  useEffect(() => {
    if (pageType === 'android') {
      Fetch(`${apiUrl}/plans/cms?type=${pageType}`, token, (result) => {
        const android_plans = convertIdToKey(result.plans)

        android_plans.forEach(plan => {
          if (!plan.name) {
            plan.name = plan.planId
          }
        })
        setAndroidPlans(android_plans);
      })
    }
  }, [apiUrl, token, pageType, confirmLoading])

  const handleSubmit = async () => {
    setLoading(true)
    console.log("PageType", pageType)
    if (pageType === 'web') {
      try {
        setConfirmLoading(true)
        let init_price = form.getFieldValue('init_price')
        let init_symbol = form.getFieldValue('init_symbol')
        console.log('init_price', init_price, init_symbol);
        let price_t = {} // to store the sales price keys and values
        let mrp_t = {} // to store the mrp keys and values
        // Object.entries(price).map(([k, v]) =>
        //   (k.includes("_MRP") ? (mrp_t[k] = v) : (price_t[k] = v)))
        let price_list = form.getFieldValue('price_list')
        console.log('price_list', price_list)
        let add_init = { 'symbol': init_symbol, 'price': init_price }
        console.log(add_init)
        price_list.push(add_init)
        console.log('final price object', price_list);
        let values = form.getFieldsValue()
        values = { ...values, price: price_list, mrp: mrp_t }
        console.log('values before submit - ', values)
        Post(
          `${apiUrl}/plans`,
          token,
          { ...values, syncApplePlan: syncApplePlan, syncGooglePlan: syncGooglePlan },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

    if (pageType === 'apple') {
      try {
        setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log(values.planId)
        Post(
          `${apiUrl}/plans/applePlan`,
          token,
          { ...values, planType: "applePlan", },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

    if (pageType === 'android') {
      try {
        setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log(values.planId)
        Post(
          `${apiUrl}/plans/androidPlan`,
          token,
          { ...values, planType: "androidPlan", },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan created'
              })
            }
            form.resetFields()
            setModalVisible(false)
            setLoading(false)
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Add Plan Error',
              description: 'Check console for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Add Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      } finally {
        setConfirmLoading(false)
      }
    }

  }

  const getPlanDetails = async (id) => {
    console.log("pageType: ", pageType)
    if (pageType === 'web') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        const { ...others } = result;
        // console.log("before", result)
        setEditPlan({ ...result })
        // console.log("result", result);
        // others.price = { ...result.price, ...result.mrp }
        // console.log("others", others)
        form.setFieldsValue(others);
        if (others.syncApplePlan) setSyncApplePlan(true);
        if (others.syncGooglePlan) setSyncGooglePlan(true);
        setPlanId(id);
      })
    }
    if (pageType === 'apple') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        setEditPlan({ planId: result.planId })
        console.log("result: ", result)
        form.setFieldValue("planId", result.planId);
        form.setFieldValue("price", result.price);
        form.setFieldValue("duration", result.duration);
        setPlanId(id);
      })
    }
    if (pageType === 'android') {
      Fetch(`${apiUrl}/plans/cms/${id}?type=${pageType}`, token, (result) => {
        setEditPlan({ planId: result.planId })
        console.log("result: ", result)
        form.setFieldValue("planId", result.planId);
        form.setFieldValue("price", result.price);
        form.setFieldValue("duration", result.duration);
        setPlanId(id);
      })
    }

  }

  const handleEditSubmit = async () => {
    setLoading(true)
    if (pageType === 'web') {
      try {
        await setConfirmLoading(true)
        // let price = form.getFieldValue('price')
        // let price_t = {} // to store the sales price keys and values
        // let mrp_t = {} // to store the mrp keys and values
        // Object.entries(price).map(([k, v]) =>
        //   (k.includes("_MRP") ? (mrp_t[k] = v) : (price_t[k] = v)))
        let values = form.getFieldsValue()
        values = { ...values, syncApplePlan: syncApplePlan, syncGooglePlan: syncGooglePlan }
        // console.log(values)
        Put(
          `${apiUrl}/plans/${planId}`,
          token,
          { ...values },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
            }
          },
          () => {
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === 'apple') {
      console.log("pageEdit: ", pageType)
      try {
        await setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log("Edit Values: ", values)
        Put(
          `${apiUrl}/plans/applePlan/${planId}`,
          token,
          { ...values, planType: "applePlan" },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
            }
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === 'android') {
      console.log("pageEdit: ", pageType)
      try {
        await setConfirmLoading(true)
        let values = form.getFieldsValue()
        console.log("Edit Values: ", values)
        Put(
          `${apiUrl}/plans/androidPlan/${planId}`,
          token,
          { ...values, planType: "androidPlan" },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Edited successfully'
              })
              form.resetFields()
              setEditModalVisible(false)
              setPlanId(null)
              setLoading(false)
            }
          },
          () => {
            setLoading(false)
            notification.error({
              message: 'Error updating plan',
              description: 'Please check logs for more details'
            })
          }
        )
      } catch (err) {
        setLoading(false)
        console.error(err)
        notification.error({
          message: 'Edit Plan Error',
          description: 'Required fields are incorrect/missing'
        })
      }
      finally {
        await setConfirmLoading(false)
      }
    }
  }

  const toggleState = async (planId) => {
    console.log(planId)
    console.log("Page for Toggling Status: ", pageType)
    if (pageType === 'web') {
      const toggledFlag = !plans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }
    if (pageType === "apple") {
      const toggledFlag = !applePlans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/applePlan/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }

    if (pageType === "android") {
      const toggledFlag = !androidPlans.filter(p => p.key === planId)[0].suspended
      try {
        await setConfirmLoading(true)
        Patch(
          `${apiUrl}/plans/androidPlan/${planId}`,
          token,
          { suspended: toggledFlag },
          (result) => {
            if (result.success) {
              notification.success({
                message: 'Success',
                description: 'Plan state toggled successfully'
              })
            }
          },
          () => {
            notification.error({
              message: 'Plan State Toggle Error',
              description: 'Check console for more details'
            })
          }
        )
      } finally {
        await setConfirmLoading(false)
      }
    }
  }

  const handlePageChange = (page) => {
    console.log("PageChange: ", page)
    if (page === "web") {
      setPageType("web")
      setData(plans)
    }
    if (page === "apple") {
      setPageType("apple")
      setData(applePlans)
    }
    if (page === "android") {
      setPageType("android")
      setData(androidPlans)
    }
  }

  // const codeMap = (
  //   <>
  //     <Form.Item name={'symbol'} label="symbol">
  //       <Select style={{ width: '250px' }} placeholder={'Select Currency'}>
  //         <Option value={'Frequently Used'} disabled>Frequently Used</Option>
  //         {frequentCodes && frequentCodes.map((cc) => (
  //           <Option key={cc.country} value={cc.symbol}>
  //             <div>{cc.symbol}-{cc.country}</div>
  //           </Option>
  //         ))}
  //         <Option value={'All Others'} disabled>All others</Option>
  //         {otherCodes && otherCodes.map((cc) => (
  //           <Option key={cc.country} value={cc.symbol}>
  //             <div>{cc.symbol}-{cc.country}</div>
  //           </Option>
  //         ))}
  //       </Select>
  //     </Form.Item>
  //   </>
  // )

  const addToList = (value) => {
    console.log('value - ', value);
  }

  return (
    <>
      <div className="manage-plans-wrapper">
        <Space direction='horizontal' size={"middle"}>
          <Select
            style={{ width: 200, marginBottom: 20, }}
            placeholder="Select Plan Type"
            showSearch
            onChange={handlePageChange}
            defaultValue='web'
          >
            <Option value="web">Web Plans</Option>
            <Option value="apple">Apple Plans</Option>
            <Option value="android">Google Play Plans</Option>
          </Select>
        </Space>
        <Table dataSource={data}>
          <Column title="Name" dataIndex="name" key="name" align="center" />
          {pageType === "web" && (
            <>
              <Column title="Price" dataIndex="price" key="price" align="center"
                // render={(_, record) => record.price && Object.entries(record.price).map(([cc, price]) => (
                //   <Tag>{cc} : {price}</Tag>
                // ))}
                render={(_, record) => record.price && (record.price).map((p) => (
                  <Tag color='blue'>{p.symbol}: {p.price}</Tag>
                ))}
              />
              {/* <Column title={'Default Currency'} align='center'
                render={(text, record) => (
                  <Space size="middle">
                    <Select placeholder="Select Currency" allowClear>
                      {record.defaultOptions && (record.defaultOptions).map((d) => (
                        <Option value={d} key={d}>{d}</Option>
                      ))}
                    </Select>
                  </Space>
                )} /> */}
            </>)}
          {pageType === "web" && (<Column
            title="Duration (days)"
            dataIndex="duration"
            key="duration"
            align="center"
          />)}
          <Column
            title="Status"
            dataIndex="suspended"
            key="suspended"
            align="center"
            render={v => v ? 'Suspended' : 'Active'}
          />
          <Column
            title="Actions"
            key="action"
            align="center"
            render={(text, record) => (
              <Space size="middle">
                <a
                  onClick={() => {
                    setPlanId(record.key);
                    getPlanDetails(record.key);
                    setEditModalVisible(true);
                    console.log(record.key, 'recordkey for edit or toggleStatus');
                  }}
                >
                  {<EditFilled />}
                </a>
                <a onClick={() => toggleState(record.key)}>
                  {record.suspended ? <PlayCircleOutlined /> : <PauseCircleOutlined />}
                </a>
              </Space>
            )}
          />
        </Table>
        <PlusCircleTwoTone
          twoToneColor="#1890FF"
          style={{ fontSize: '48px' }}
          className="add-plan-btn"
          onClick={() => { setModalVisible(true); console.log(pageType) }}
        />
        {/* <CloudDownloadOutlined
          className="export-btn"
          onClick={() => handleExportClick(apiUrl, token, 'plans')}
        /> */}
        <Modal
          title={`Add ${pageType} plan`}
          visible={modalVisible}
          onOk={handleSubmit}
          okText="Submit"
          onCancel={() => { setModalVisible(false); form.resetFields(); }}
          confirmLoading={confirmLoading}
          maskClosable={false}
          destroyOnClose={true}
        // width={'33%'}
        >
          <Form form={form} layout="vertical" initialValues={{ gender: 'M' }}>
            {pageType === "web" && (<>
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false} placeholder={'Select Duration'}>
                  <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option>
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
              <Card title={'Pricing'}>
                <Space
                  style={{
                    marginBottom: 0,
                  }}
                  align="inline"
                >
                  <Form.Item
                    name={'init_price'}
                    rules={[
                      {
                        required: true,
                        message: 'Missing Price',
                      },
                    ]}
                    noStyle
                  >
                    <InputNumber
                      placeholder='Enter the price'
                      addonBefore={(
                        <>
                          <Form.Item
                            name={'init_symbol'}
                            label='symbol'
                            noStyle
                            initialValue={'INR'}
                          >
                            <Select style={{ width: '250px' }} placeholder={'Select Currency'} defaultValue={'INR'}>
                              <Option value={'Frequently Used'} disabled>Frequently Used</Option>
                              {frequentCodes && frequentCodes.map((cc) => (
                                <Option key={cc.code} value={cc.code}>
                                  <div>{cc.symbol}-{cc.country}</div>
                                </Option>
                              ))}
                              <Option value={'All Others'} disabled>All others</Option>
                              {otherCodes && otherCodes.map((cc) => (
                                <Option key={cc.code} value={`${cc.symbol}-${cc.country}`}>
                                  <div>{cc.symbol}-{cc.country}</div>
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </>
                      )}
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                </Space>
                <Form.List name="price_list">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: 'flex',
                            marginTop: 15,
                            marginBottom: 10,
                          }}
                          align="inline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'price']}
                            label='Price'
                            rules={[
                              {
                                required: true,
                                message: 'Missing Price',
                              },
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder='Enter the price'
                              addonBefore={(
                                <>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'symbol']}
                                    label='symbol'
                                    noStyle
                                  >
                                    <Select style={{ width: '250px' }} placeholder={'Select Currency'} onChange={(e) => { addToList(e) }}>
                                      <Option value={'Frequently Used'} disabled>Frequently Used</Option>
                                      {frequentCodes && frequentCodes.map((cc) => (
                                        <Option key={cc.code} value={cc.code}>
                                          <div>{cc.symbol}-{cc.country}</div>
                                        </Option>
                                      ))}
                                      <Option value={'All Others'} disabled>All others</Option>
                                      {otherCodes && otherCodes.map((cc) => (
                                        <Option key={cc.code} value={`${cc.symbol}-${cc.country}`}>
                                          <div>{cc.symbol}-{cc.country}</div>
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </>
                              )}
                              style={{
                                width: '100%',
                              }}
                            />
                          </Form.Item>
                          <PlusCircleOutlined onClick={() => add()} />
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      {fields.length === 0 && (<Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Currency
                        </Button>
                      </Form.Item>)}
                    </>
                  )}
                </Form.List>
              </Card>
              {/* <Form.Item
                name={'defaultCurrency'}
                label={'Default Currency'}
                help={'In case the demanded currency not found this will act as a default currency'}
                style={{ marginTop: 3, }}
                required={false}
              >
                <Select placeholder={'Select a default currency'}>
                  {frequentCodes && frequentCodes.map((c) => (
                    <Option key={c.code} value={c.code}>{`${c.symbol}-${c.country}`}</Option>
                  ))}
                  {otherCodes && otherCodes.map((c) => (
                    <Option key={c.code} value={c.code}>{`${c.symbol}-${c.country}`}</Option>
                  ))}
                </Select>
              </Form.Item> */}
              <Card title={'Sync for '}>
                <Form.Item
                  name={'appleSync'}
                >
                  <Checkbox defaultChecked={false} onChange={(e) => setSyncApplePlan(e.target.checked)}>Apple Plans</Checkbox>
                </Form.Item>
                <Form.Item
                  name={'androidSync'}
                >
                  <Checkbox defaultChecked={false} onChange={(e) => setSyncGooglePlan(e.target.checked)}>Google Plans</Checkbox>
                </Form.Item>
              </Card>
              {/* <Form.List
                name="features"
                rules={[
                  {
                    validator: async (_, features) => {
                      if (!features || features.length < 2)
                        return Promise.reject(new Error('At least 2 features'));
                    },
                  },
                ]}
              >
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {fields.map((field, index) => (
                      <Form.Item
                        label={index === 0 ? 'Features' : ''}
                        required={false}
                        key={field.key}
                      >
                        <Form.Item
                          {...field}
                          validateTrigger={['onChange', 'onBlur']}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message:
                                'Please input feature or delete this field.',
                            },
                          ]}
                          noStyle
                        >
                          <Input style={{ width: '95%' }} />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-btn"
                            onClick={() => remove(field.name)}
                          />
                        ) : null}
                      </Form.Item>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        icon={<PlusOutlined />}
                      >
                        Add feature
                      </Button>
                      <Form.ErrorList errors={errors} />
                    </Form.Item>
                  </>
                )}
              </Form.List> */}
            </>
            )}
            {(pageType === "apple") && (<>
              <Form.Item name="planId" label="Plan ID" rules={[{ required: true, }]}>
                <Input placeholder='Enter the Plan ID' />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in USD' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option>
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
            {(pageType === "android") && (<>
              <Form.Item name="planId" label="Plan ID" rules={[{ required: true, }]}>
                <Input placeholder='Enter the Plan ID' />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in INR' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
          </Form>
        </Modal >
        <Modal
          title="Edit Plan"
          visible={editModalVisible}
          onOk={handleEditSubmit}
          okText="Update"
          onCancel={() => { setEditModalVisible(false); form.resetFields() }}
          confirmLoading={confirmLoading}
          maskClosable={false}
        >
          <Form form={form} layout="vertical" initialValues={{ gender: 'M' }}>
            {pageType === "web" && (<>
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={true} placeholder={'Select Duration'}>
                  <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option>
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
              <Card title={'Pricing'}>
                {/* <Space
                  style={{
                    marginBottom: 0,
                  }}
                  align="inline"
                >
                  <Form.Item
                    name={'init_price'}
                    rules={[
                      {
                        required: true,
                        message: 'Missing Price',
                      },
                    ]}
                    noStyle
                  >
                    <InputNumber
                      placeholder='Enter the price'
                      addonBefore={(
                        <>
                          <Form.Item
                            name={'init_symbol'}
                            label='symbol'
                            noStyle
                            initialValue={'INR'}
                          >
                            <Select style={{ width: '250px' }} placeholder={'Select Currency'} defaultValue={'INR'}>
                              <Option value={'Frequently Used'} disabled>Frequently Used</Option>
                              {frequentCodes && frequentCodes.map((cc) => (
                                <Option key={cc.code} value={cc.code}>
                                  <div>{cc.symbol}-{cc.country}</div>
                                </Option>
                              ))}
                              <Option value={'All Others'} disabled>All others</Option>
                              {otherCodes && otherCodes.map((cc) => (
                                <Option key={cc.code} value={`${cc.symbol}-${cc.country}`}>
                                  <div>{cc.symbol}-{cc.country}</div>
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </>
                      )}
                      style={{
                        width: '100%',
                      }}
                    />
                  </Form.Item>
                </Space> */}
                <Form.List name="price">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{
                            display: 'flex',
                            marginTop: 15,
                            marginBottom: 10,
                          }}
                          align="inline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'price']}
                            label='Price'
                            rules={[
                              {
                                required: true,
                                message: 'Missing Price',
                              },
                            ]}
                            noStyle
                          >
                            <InputNumber
                              placeholder='Enter the price'
                              addonBefore={(
                                <>
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'symbol']}
                                    label='symbol'
                                    noStyle
                                  >
                                    <Select style={{ width: '250px' }} placeholder={'Select Currency'} onChange={(e) => { addToList(e) }}>
                                      <Option value={'Frequently Used'} disabled>Frequently Used</Option>
                                      {frequentCodes && frequentCodes.map((cc) => (
                                        <Option key={cc.code} value={cc.code}>
                                          <div>{cc.symbol}-{cc.country}</div>
                                        </Option>
                                      ))}
                                      <Option value={'All Others'} disabled>All others</Option>
                                      {otherCodes && otherCodes.map((cc) => (
                                        <Option key={cc.code} value={`${cc.symbol}-${cc.country}`}>
                                          <div>{cc.symbol}-{cc.country}</div>
                                        </Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </>
                              )}
                              style={{
                                width: '100%',
                              }}
                            />
                          </Form.Item>
                          <PlusCircleOutlined onClick={() => add()} />
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      {fields.length === 0 && (<Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Currency
                        </Button>
                      </Form.Item>)}
                    </>
                  )}
                </Form.List>
              </Card>
              {/* <Form.Item
                name={'defaultCurrency'}
                label={'Default Currency'}
                help={'In case the demanded currency not found this will act as a default currency'}
                style={{ marginTop: 3, }}
                required={false}
              >
                <Select placeholder={'Select a default currency'}>
                  {frequentCodes && frequentCodes.map((c) => (
                    <Option key={c.code} value={c.code}>{`${c.symbol}-${c.country}`}</Option>
                  ))}
                  {otherCodes && otherCodes.map((c) => (
                    <Option key={c.code} value={c.code}>{`${c.symbol}-${c.country}`}</Option>
                  ))}
                </Select>
              </Form.Item> */}
              <Card title={'Sync for '}>
                <Form.Item
                  name={'appleSync'}
                >
                  <Checkbox checked={syncApplePlan} onChange={(e) => setSyncApplePlan(e.target.checked)}>Apple Plans</Checkbox>
                </Form.Item>
                <Form.Item
                  name={'androidSync'}
                >
                  <Checkbox checked={syncGooglePlan} onChange={(e) => setSyncGooglePlan(e.target.checked)}>Google Plans</Checkbox>
                </Form.Item>
              </Card>
            </>
            )}
            {(pageType === "apple") && (<>
              <Form.Item name="planId" label="Pland ID" rules={[{ required: true, }]}>
                <Input placeholder="Enter Plan ID" />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in USD' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
            {(pageType === "android") && (<>
              <Form.Item name="planId" label="Pland ID" rules={[{ required: true, }]}>
                <Input placeholder="Enter Plan ID" />
              </Form.Item>
              <Form.Item name={"price"} label="Price" rules={[{ required: true }]}>
                <InputNumber placeholder='Enter the Price in INR' />
              </Form.Item>
              <Form.Item
                name="duration"
                label="Duration"
                rules={[{ required: true }]}
              >
                <Select disabled={false}>
                  {/* <Select.Option key={7} value={7}>
                    {"Weekly"}
                  </Select.Option> */}
                  <Select.Option key={30} value={30}>
                    {"Monthly"}
                  </Select.Option>
                  <Select.Option key={90} value={90}>
                    {"Quarterly"}
                  </Select.Option>
                  <Select.Option key={180} value={180}>
                    {"Half-Yearly"}
                  </Select.Option>
                  <Select.Option key={365} value={365}>
                    {"Yearly"}
                  </Select.Option>
                </Select>
              </Form.Item>
            </>)}
          </Form>
        </Modal>
      </div >
    </>
  );
}

export default ManagePlans